import { api, getList } from "./api";
import type { Alerte } from "../types/alerte";

export const getAlertes = async (): Promise<Alerte[]> => {
  return getList<Alerte>("/alertes/");
};

export const getAlerteById = async (id: string): Promise<Alerte> => {
  const response = await api.get<Alerte>(`/alertes/${id}/`);
  return response.data;
};

export const deleteAlerte = async (id: string): Promise<void> => {
  await api.delete(`/alertes/${id}/`);
};
